import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PublishStoryComponentTextModel } from '../../models/publish-story-component-text.model';
import { PublishMetadataModel } from '../../models/publish-metadata.model';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-publish-story',
    templateUrl: './publish-story.component.html',
    styleUrls: ['./publish-story.component.scss'],
    standalone: false
})

export class PublishStoryComponent extends AbstractDialogComponent {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() public id: string;
    @Input() public storyInfo: boolean = true;
    @Input() public localization: PublishStoryComponentTextModel = new PublishStoryComponentTextModel();
    @Input() public headerIcon: string = '';
    @Input() public scheduleDate: string = '';
    @Input() public author: string = '';
    @Input() public guideline: string = '';
    @Input() public metadata: PublishMetadataModel[] = [];
    @Input() public disclaimers: string[] = [];
    @Input() public header: string = '';
    @Input() showPublishButton: boolean;
    @Input() showPublishLoader: boolean;
    @Output() doPublish: EventEmitter<boolean> = new EventEmitter<boolean>();
    public iAgree: boolean = false;
    public closableStatus: boolean = true;
    public disclaimerStatuses: boolean[];

    constructor(public coreDialogService: CoreDialogService) {
        super(coreDialogService, 'PublishStory');
        this.showPublishLoader = false;
        this.showPublishButton = true;
        this.closableStatus = true;
        this.disclaimerStatuses = [];
        for (let i = 0; i < this.disclaimers.length; i++) {
            this.disclaimerStatuses.push(false);
        }
    }

    public onPublishClick(): void {
        this.closableStatus = false;
        this.showPublishLoader = true;
        this.showPublishButton = false;
        this.doPublish.emit(true);
        this.closeDialog(true);
    }
    public getIAgreeStatus(): void {
        for (let i = 0; i < this.disclaimers.length; i++) {
            if (this.disclaimerStatuses[i] !== true) {
                this.iAgree = false;
                return;
            }
        }
        this.iAgree = true;
    }

    public cancel() {
        this.closeDialog(false);
    }
}
